// extracted by mini-css-extract-plugin
export default {"whatsaap":"WhatsApp_whatsaap__29goj"};